import React, { useCallback, useState } from "react";
import { css } from "glamor";
import { colors, spacing } from "../library";

const containerClass = css({
  marginTop: spacing.s,
  marginBottom: spacing.m,
});

const tabBarClass = css({
  display: "flex",
  gap: spacing.l,
  borderBottom: `2px solid ${colors.greyLight}`,
});

const tabBase = {
  display: "flex",
  alignItems: "center",
  gap: spacing.xs,
  padding: `${spacing.s} 0`,
  fontSize: 16,
  fontWeight: 700,
  cursor: "pointer",
  border: "none",
  backgroundColor: "transparent",
  borderBottom: "3px solid transparent",
  marginBottom: -2,
  transition: "color 150ms ease, border-color 150ms ease",
  color: colors.greyDark,
  ":hover": {
    color: colors.primary,
  },
};

const tabClass = css(tabBase);

const tabHighlightClass = css({
  ...tabBase,
  backgroundColor: "#EAF6FF",
  color: colors.primary,
  borderRadius: "6px 6px 0 0",
  padding: `${spacing.s} ${spacing.m}`,
});

const tabActiveClass = css({
  ...tabBase,
  color: colors.primary,
  borderBottomColor: colors.primary,
});

const tabActiveHighlightClass = css({
  ...tabBase,
  color: colors.primary,
  borderBottomColor: colors.primary,
  backgroundColor: "#EAF6FF",
  borderRadius: "6px 6px 0 0",
  padding: `${spacing.s} ${spacing.m}`,
});

export default function CourseTabMenu({
  panes = [],
  initialPaneIndex = 0,
  onTabChange,
}) {
  const [selectedIndex, setSelectedIndex] = useState(initialPaneIndex);

  const handleClick = useCallback(
    (index) => {
      setSelectedIndex(index);
      if (onTabChange) onTabChange(index);
    },
    [onTabChange]
  );

  const renderPane = panes[selectedIndex]?.render;

  return (
    <div className={containerClass}>
      <div className={tabBarClass}>
        {panes.map((pane, index) => (
          <button
            key={index}
            className={
              index === selectedIndex
                ? pane.highlight ? tabActiveHighlightClass : tabActiveClass
                : pane.highlight ? tabHighlightClass : tabClass
            }
            onClick={() => handleClick(index)}
          >
            {pane.title}
          </button>
        ))}
      </div>

      {renderPane && renderPane()}
    </div>
  );
}
